import {Ref, ref} from 'vue';

export class EditorUploadsStoreControllerClass {
	private static _instance: EditorUploadsStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorUploadsStoreControllerClass());
	}

	private constructor() {}

	private _reloadRequired: Ref<boolean> = ref(false);

	// getters

	reload_required(): boolean {
		return this._reloadRequired.value;
	}

	// mutations
	set_reload_required() {
		this._reloadRequired.value = true;
	}
	unset_reload_required() {
		this._reloadRequired.value = false;
	}
}

export const EditorUploadsStoreController = EditorUploadsStoreControllerClass.instance();
